export const IMAGE_TYPES = {
  DEFAULT: 0,
};

export default {
  IMAGE_TYPES,
};
